<template>
  <div id="order_history_detail">
    <section id="totalPrice">
      <div class="order_title">
        <font color="ffffff">ご請求金額</font>
      </div>
      <div class="input_list cart_price" style="background: #FFFFFF">
        <ul>
          <li>
            <table class="order_price_table">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>金額</th>
                </tr>
              </thead>
              <tbody>
                <tr class="n_separator">
                  <td>商品・配送 計</td>
                  <td>{{formatPrice(orderPrice.itemSubTotalPrice)}}</td>
                </tr>
                <tr>
                  <td>消費税(10%)</td>
                  <td>{{formatPrice(orderPrice.itemSubTotalTax)}}</td>
                </tr>
                <tr class="n_separator">
                  <td>税込金額(A)</td>
                  <td>{{formatPrice(orderPrice.itemTotalPrice)}}</td>
                </tr>
              </tbody>
            </table>
            <table class="order_price_table" style="margin-top: 40px" v-if="orderPrice.optSubTotalPrice">
              <tbody>
                <tr class="n_separator tbl_space">
                  <td>組立設置他サービス 計</td>
                  <td>{{formatPrice(orderPrice.optSubTotalPrice)}}</td>
                </tr>
                <tr v-if="orderPrice.discntPrice">
                  <td>諸経費割引</td>
                  <td>(-{{formatPrice(orderPrice.discntPrice)}})</td>
                </tr>
                <tr class="n_separator" v-if="orderPrice.discntPrice">
                  <td>小計</td>
                  <td>{{formatPrice(orderPrice.discntSubTotalPrice)}}</td>
                </tr>
                <tr>
                  <td>消費税(10%)</td>
                  <td>{{formatPrice(orderPrice.optTotalTax)}}</td>
                </tr>
                <tr class="n_separator">
                  <td>税込金額(B)</td>
                  <td>{{formatPrice(orderPrice.optTotalPrice)}}</td>
                </tr>
              </tbody>
            </table>
            <div class="div_table" style="margin-top: 40px">
              <div v-if="orderPrice.optSubTotalPrice">(A) + (B)</div>
              <div v-else>(A)</div>
            </div>
            <div class="div_table">
              <div>ご請求額合計</div>
              <div>{{formatPrice(orderPrice.totalPrice)}}</div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'OrderPrice',
  components: {
  },
  props: {
    orderPrice: Object
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    }
  }
}
</script>
<style src="../../../css/order/orderDetail.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/OrderPrice.vue